import { type ChainflipAsset } from '@chainflip/utils/chainflip';
import { getAllBoostPoolsCacheQuery } from '@/shared/graphql/cache/boost';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

export const useAllBoostPools = () => {
  const data = useGqlQuery(getAllBoostPoolsCacheQuery, {
    context: { clientName: 'statechainCache' },
  });

  return {
    ...data,
    boostPools: data.data?.pools?.nodes,
    totalBoostLiquidityUsd: data.data?.pools?.nodes.reduce(
      (acc, pool) =>
        acc + Number(pool.unavailableAmountValueUsd) + Number(pool.availableAmountValueUsd),
      0,
    ),
    boostPoolAvailableAmounts:
      data.data?.pools?.nodes.reduce(
        (acc, pool) =>
          Object.assign(acc, {
            [pool.asset]: BigInt(pool.availableAmount) + BigInt(acc[pool.asset] ?? 0n),
          }),
        {} as Record<ChainflipAsset, bigint | undefined>,
      ) || ({} as Record<ChainflipAsset, bigint | undefined>),
  };
};
